module.exports = __webpack_public_path__ + "static/media/spades_10.bcbecaef.png";